import React, { Component } from "react";
import {
  Form,
  Card,
  Button,
  Row,
  Col,
  Alert,
  Modal,
  Spinner,
  Badge,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import DataTable from "react-data-table-component";
import LoadingOverlay from "./LoadingOverlay";
export default class Generatesamplepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      userName: sessionStorage.getItem("userName"),
      bulkquoteRequestId: sessionStorage.getItem("bulkquoteRequestId"),
      // Company & Employee Data
      selectedCompany: "",
      companies: [],
      data: [],
      filteredData: null,
      currentPage: 1,
      itemsPerPage: 100,
      selectedRows: [],
      tableClms: [
        {
          name: "S.No",
          cell: (row, index) =>
            (this.state.currentPage - 1) * this.state.itemsPerPage + index + 1,
        },
        {
          name: "Emp Id",
          selector: (row, i) => row.employeeId,
          sortable: true,
          cell: (row) => <span>{row.employeeId}</span>,
        },
        {
          name: "Adults Count",
          selector: (row, i) => row.adultsCount,
          sortable: true,
          cell: (row) => <span>{row.adultsCount}</span>,
        },
        {
          name: "Children Count",
          selector: (row, i) => row.childrenCount,
          sortable: true,
          cell: (row) => <span>{row.childrenCount}</span>,
        },
        {
          name: "Parents Count",
          selector: (row, i) => row.parentsCount,
          sortable: true,
          cell: (row) => <span>{row.parentsCount}</span>,
        },
        {
          name: "Coverage Family Definition",
          selector: (row, i) => row.coverageFamilyDefinition,
          sortable: true,
          cell: (row) => <span>{row.coverageFamilyDefinition}</span>,
        },
        {
          name: "Eldest Age",
          selector: (row, i) => row.eldestAge,
          sortable: true,
          cell: (row) => <span>{row.eldestAge}</span>,
        },
        {
          name: "Parents Count",
          selector: (row, i) => row.parentsCount,
          sortable: true,
          cell: (row) => <span>{row.parentsCount}</span>,
        },
        {
          name: "PINCODE",
          selector: (row, i) => row.pincode,
          sortable: true,
          cell: (row) => <span>{row.pincode}</span>,
        },
        {
          name: "Sum Insured",
          selector: (row, i) => row.sumInsured,
          sortable: true,
          cell: (row) => <span>{row.sumInsured}</span>,
        },
        {
          name: "Premium",
          selector: (row, i) => row.premium,
          sortable: true,
          cell: (row) => <span>{row.premium}</span>,
        },
        {
          name: "Zone",
          selector: (row, i) => row.zone,
          sortable: true,
          cell: (row) => <span>{row.zone}</span>,
        },
      ],
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };
  componentDidMount() {
    this.fetchgeneratequotesummary();
  }
  fetchgeneratequotesummary = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("bulkquoteRequestId", this.state.bulkquoteRequestId);
    fetch(configData.api_url + "C_Bulkquoteefd/getbybulkquoterequestid", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.data || [] });
        }
      });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  //totla gst with premium
  calculateTotals = () => {
    const dataToCalculate = this.state.filteredData || this.state.data;
    const totalPremium = dataToCalculate.reduce((sum, row) => {
      return sum + (parseFloat(row.premium) || 0);
    }, 0);

    const gstAmount = totalPremium * 0.18;
    const finalAmount = totalPremium + gstAmount;

    return {
      totalPremium: totalPremium.toFixed(2),
      gstAmount: gstAmount.toFixed(2),
      finalAmount: finalAmount.toFixed(2),
    };
  };
  render() {
    const {
      data,
      filteredData,
      currentPage = 1,
      itemsPerPage = 100,
    } = this.state;
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );
    const totals = this.calculateTotals();
    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <h3>Generate Quote Sample Page</h3>
        <div style={{ marginRight: "5px" }}>
          {/* searchbar,pagination,filter */}
          <input
            type="text"
            onChange={this.handleFilter}
            placeholder="Search..."
            style={{ marginBottom: "10px" }}
          />
          <>
            <DataTable
              data={paginatedData}
              columns={this.state.tableClms}
              pagination
              paginationServer
              paginationTotalRows={
                this.state.filteredData
                  ? this.state.filteredData.length
                  : this.state.data.length
              }
              onChangeRowsPerPage={this.handlePerRowsChange}
              onChangePage={this.handlePageChange}
              paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
              paginationPerPage={100}
              keyField="id"
              paginationRowsPerPageOptions={[
                10, 20, 30, 50, 60, 70, 80, 90, 100,
              ]}
              className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
            />
            {/* Total Summary Row */}
            <div
              className="premium-summary"
              style={{
                marginTop: "20px",
                padding: "15px",
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "4px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "30px",
                  fontWeight: "bold",
                }}
              >
                <div>
                  <span>Total Premium: </span>
                  <span style={{ color: "#007bff" }}>
                    ₹ {totals.totalPremium}
                  </span>
                </div>
                <div>
                  <span>GST (18%): </span>
                  <span style={{ color: "#28a745" }}>₹ {totals.gstAmount}</span>
                </div>
                <div>
                  <span>Final Amount: </span>
                  <span style={{ color: "#dc3545", fontSize: "1.1em" }}>
                    ₹ {totals.finalAmount}
                  </span>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    );
  }
}
